/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
// import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  API_BASE_URL,
  CHANGE_PASSWORD,
  GET_USER_STORES,
  GET_VSTORE_PROD,
  GET_HEADER_NOTIFYS,
} from "../../Config";
import Axios from "axios";
import Select from "react-select";
// import { faWindowRestore } from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";
import qs from "qs";
import Swal from "sweetalert2";
import "./header.css";
import UserIcon from "./usericon.svg";
// import logoimg from './iBizAccounts.png';

const Header = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [userStores, setUserStores] = useState([]);
  const [notifysData, setNotifysData] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const [layoutTheme, setLayoutTheme] = useState(
    localStorage.getItem("layoutThemeColors") || "light"
  );
  const [layoutColor, setlayoutColor] = useState(
    localStorage.getItem("colorschema") || "light_mode"
  );

  const [barcode, setBarcode] = useState("");
  const [loading, setLoading] = useState(false);
  const [pwdSubmitBtnLoading, setPwdSubmitBtnLoading] = useState(false);
  const [productData, setProductData] = useState(null);
  const [offcanvasWidth, setOffcanvasWidth] = useState("35%");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOffcanvasWidth("85%");
      } else {
        setOffcanvasWidth("45%");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const initialFormData = {
    username: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  const handleCancel = () => {
    setFormData(initialFormData);
  };
  const [formData, setFormData] = useState(initialFormData);

  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-layout-mode", layoutColor);
    document.documentElement.setAttribute("data-nav-color", layoutTheme);
  }, [layoutColor, layoutTheme]);

  useEffect(() => {
    const savedTheme = localStorage.getItem("colorschema");
    if (savedTheme === "dark_mode") {
      setIsDarkMode(true);
      setDarkMode();
    } else {
      setLightMode();
    }
  }, []);

  // Function to set dark mode
  const setDarkMode = () => {
    localStorage.setItem("colorschema", "dark_mode");
    document.documentElement.setAttribute("data-layout-mode", "dark_mode");
  };

  const setLightMode = () => {
    localStorage.setItem("colorschema", "light_mode");
    document.documentElement.setAttribute("data-layout-mode", "light_mode");
  };

  // Toggle between dark and light mode
  const handleThemeToggle = () => {
    if (isDarkMode) {
      setLightMode();
    } else {
      setDarkMode();
    }
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate();

  const handleLogout = (event) => {
    event.preventDefault();

    sessionStorage.clear();
    localStorage.clear();

    navigate("/");
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      const api = `${API_BASE_URL}${GET_HEADER_NOTIFYS}?UserId=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`;
      Axios.get(api)
        .then((response) => {
          if (response.data.Status) {
            setNotifysData(response.data.ResultData);
            // console.log(response.data.ResultData, 'notify data ......');
          } else {
            console.error("Error fetching data:", response.data);
            setNotifysData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  // data session
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data) {
            setUserStores(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  const handleStoreChange = (selectedOption) => {
    sessionStorage.setItem("selectedStoreId", selectedOption.value);
    console.log(selectedOption.value, "selected option store header page");

    // Dispatch a custom event to notify other components
    const event = new CustomEvent("storeIdChanged", {
      detail: selectedOption.value,
    });
    window.dispatchEvent(event);
  };

  const options = [
    { value: 0, label: "All" },
    ...(userStores
      ? userStores.map((store) => ({
          value: store.StoreId,
          label: store.Name,
        }))
      : []),
  ];

  const fetchProductData = debounce(async (barcodeValue) => {
    if (barcodeValue) {
      setLoading(true);
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: barcodeValue,
        ProductId: 0,
        StoreId: 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 0,
      };
      console.log(requestData, "data sending to api in headers");

      try {
        const response = await Axios.post(
          `${API_BASE_URL}${GET_VSTORE_PROD}`,
          requestData
        );
        const product = response.data?.ResultData[0];

        setProductData(product || null);
        console.log(product);
      } catch (error) {
        console.error("Error fetching product data:", error);
        setProductData(null);
      } finally {
        setLoading(false);
      }
    }
  }, 500);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setBarcode(value);
    fetchProductData(value);
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPwdSubmitBtnLoading(true);

    if (formData.newPassword !== formData.confirmPassword) {
      Swal.fire({
        title: "Error",
        text: "New password and confirm password do not match.",
        icon: "error",
      });
      setPwdSubmitBtnLoading(false);
      return;
    }

    if (
      formData.oldPassword === formData.newPassword ||
      formData.oldPassword === formData.confirmPassword
    ) {
      Swal.fire({
        title: "Error",
        text: "New password and old password are the same.",
        icon: "error",
      });
      setPwdSubmitBtnLoading(false);
      return;
    }

    const payload = {
      Name: formData.username,
      OldPassword: formData.oldPassword,
      NewPassword: formData.newPassword,
      OrgId: userDataSession.OrgId,
    };
    console.log(payload, userDataSession.UserId);
    try {
      const response = await Axios.post(
        `${API_BASE_URL}${CHANGE_PASSWORD}`,
        payload
      );

      console.log(response.data);

      if (response.data.Status) {
        setPwdSubmitBtnLoading(false);

        Swal.fire({
          title: response.data.message,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            // window.location.reload();
            sessionStorage.clear();
            localStorage.clear();
            navigate("/");
          }
        });
      } else {
        setPwdSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: response.data.message,
          icon: "error",
        });
      }
    } catch (error) {
      setPwdSubmitBtnLoading(false);
      console.error("Error changing password:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const toggleAccordion = (index, event) => {
    event.stopPropagation();
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const timeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    const intervals = [
      { label: "year", seconds: 31536000 },
      { label: "month", seconds: 2592000 },
      { label: "week", seconds: 604800 },
      { label: "day", seconds: 86400 },
      { label: "hour", seconds: 3600 },
      { label: "minute", seconds: 60 },
    ];

    for (const interval of intervals) {
      const count = Math.floor(seconds / interval.seconds);
      if (count > 0) {
        return count === 1
          ? `1 ${interval.label} ago`
          : `${count} ${interval.label}s ago`;
      }
    }

    return "just now"; // For very recent times
  };

  return (
    <>
      <div
        className={`header ${
          pathname === "/" ||
          pathname.startsWith("/view-data") ||
          pathname.startsWith("/add-sale") ||
          pathname.startsWith("/pos-jewellery") ||
          pathname.startsWith("/pos-ecommerce") ||
          pathname.startsWith("/view-indent-data")
            ? "d-none"
            : "d-block"
        }`}
      >
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          // onMouseLeave={expandMenu}
          // onMouseOver={expandMenuOpen}
        >
          <Link className="logo logo-normal">
            <img src={`assets/img/iBizAccounts.png`} alt="img" />
          </Link>
          <Link className="logo logo-white">
            <ImageWithBasePath
              src={`assets/img/${userDataSession.OrgId}.png`}
              alt="img"
            />
          </Link>
          <Link className="logo-small">
            <ImageWithBasePath
              src={`assets/img/${userDataSession.OrgId}.png`}
              alt="img"
            />
          </Link>
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}

        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>

        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-searchinputs ">
            <div className="top-nav-search">
              <form action="#" className="dropdown">
                <div
                  className="searchinputs dropdown-toggle"
                  id="dropdownMenuClickable"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="false"
                >
                  <input
                    type="text"
                    placeholder="Search"
                    value={barcode}
                    onChange={handleInputChange}
                  />
                  <div className="search-addon">
                    <span>
                      <XCircle className="feather-14" />
                    </span>
                  </div>
                </div>
                <div
                  className="dropdown-menu search-dropdown"
                  aria-labelledby="dropdownMenuClickable"
                >
                  <div className="search-info">
                    {loading ? (
                      <div className="text-center m-auto loader mt-5"></div>
                    ) : productData ? (
                      <div className="text-center search-info">
                        <Link
                          to={{
                            pathname: route.editproduct,
                            search: qs.stringify({
                              product: JSON.stringify(productData),
                            }),
                          }}
                        >
                          {productData?.ImagePath ? (
                            <img
                              src={`https://pcuploadfiles.azurewebsites.net/download?path=${productData?.ImagePath}`}
                              alt=""
                              style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                marginTop: "-18px",
                                // marginBottom: '15px'
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "80px",
                                height: "80px",
                                backgroundColor: "#FF9F43",
                                borderRadius: "50%",
                              }}
                            >
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  backgroundColor: "#FF9F43",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "50%",
                                  fontSize: "18px",
                                  color: "#fff",
                                }}
                              >
                                {productData &&
                                typeof productData === "object" &&
                                productData?.ProductName
                                  ? productData.ProductName.charAt(
                                      0
                                    ).toUpperCase()
                                  : "N/A"}
                              </div>
                            </div>
                          )}
                          <h6 className="text-primary text-center justify-content-center my-2">
                            {productData?.ProductName}
                          </h6>
                        </Link>

                        <div className="search-info">
                          <ul className="customers">
                            <li>
                              <a>
                                BarCode
                                <p className="fw-bold">
                                  {productData?.BarCode}
                                </p>
                              </a>
                            </li>
                            <li>
                              <a>
                                SKU
                                <p className="fw-bold">
                                  {productData?.ProductSKU}
                                </p>
                              </a>
                            </li>
                            <li>
                              <a>
                                Price
                                <p className="fw-bold">
                                  {productData?.AvgPrice}
                                </p>
                              </a>
                            </li>
                            <li>
                              <a>
                                Stock
                                <p className="fw-bold">
                                  {productData?.StockByUsers}
                                </p>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center mt-5">No product found</p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </li>
          {/* /Search */}

          {/* Select Store */}
          <li className="nav-item dropdown has-arow main-drop select-store-dropdown">
            <div style={{ width: "12rem" }}>
              <Select
                className="select"
                options={options}
                placeholder="Choose store"
                onChange={handleStoreChange}
              />
            </div>
          </li>
          {/* /Select Store */}

          {/* Light Dark Mode */}
          <li
            className="nav-item nav-item-box"
            title={isDarkMode ? "Light Mode" : "Dark Mode"}
          >
            <Link to="#" onClick={handleThemeToggle}>
              <FeatherIcon icon={isDarkMode ? "sun" : "moon"} />
            </Link>
          </li>
          {/* Light Dark Mode */}

          {/* Full Screen */}
          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <FeatherIcon icon={`${isFullscreen ? "minimize" : "maximize"}`} />
            </Link>
          </li>
          {/* Full Screen */}

          {/* Help */}
          <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <i
                className="fa-solid fa-question fa-bounce"
                style={{ color: "#75736c" }}
              ></i>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header text-center">
                <span className="notification-title text-center">
                  Helpful Videos
                </span>
              </div>

              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <a href="#">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Raising an Indent Directly
                            </span>
                            <a
                              href="https://youtu.be/HEkxV6wbwO0"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Tutorial
                            </a>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="#">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Submitting an Indent via Excel
                            </span>
                            <a
                              href="https://youtu.be/Zxp9wv-4Pok"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Tutorial
                            </a>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className="notification-message">
                    <a href="#">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Requesting Late Indent Approval
                            </span>
                            <a
                              href="https://youtu.be/5vSxfoQLsTI"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Tutorial
                            </a>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          {/* /Help */}

          {/* Notifications */}
          <li className="nav-item dropdown nav-item-box">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <i
                className={`fa-regular fa-bell ${
                  notifysData.length > 0 ? "fa-shake" : ""
                }`}
                style={{ color: "#75736c" }}
              ></i>
              <span
                className={`badge rounded-pill ${
                  notifysData.length > 0 ? "blinking-badge" : ""
                }`}
                style={{ width: "1.2rem", height: "1.2rem" }}
              >
                {notifysData.length || 0}
              </span>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  Clear All
                </Link>
              </div>

              <div className="noti-content">
                <ul className="notification-list">
                  {notifysData &&
                    notifysData.map((item, index) => {
                      const getTimeDifference = (createdOn) => {
                        const now = new Date();
                        const createdDate = new Date(createdOn);

                        const localCreatedDate = new Date(
                          createdDate.getTime() -
                            createdDate.getTimezoneOffset() * 60000
                        );
                        const localNow = new Date(
                          now.getTime() - now.getTimezoneOffset() * 60000
                        );

                        const diffInMs = localNow - localCreatedDate;
                        const diffInMinutes = Math.floor(diffInMs / 1000 / 60);
                        const diffInHours = Math.floor(diffInMinutes / 60);
                        const diffInDays = Math.floor(diffInHours / 24);

                        if (diffInMinutes < 60) {
                          return `${diffInMinutes} mins ago`;
                        } else if (diffInHours < 24) {
                          return `${diffInHours} hours ago`;
                        } else {
                          return `${diffInDays} days ago`;
                        }
                      };

                      return (
                        <li
                          className={`notification-message ${
                            expandedIndex === index ? "active" : ""
                          }`}
                          key={index}
                          onClick={(event) => toggleAccordion(index, event)}
                        >
                          <Link to="#">
                            <div className="media d-flex">
                              <span className="avata flex-shrink-0">
                                {expandedIndex === index ? (
                                  <i className="fa-regular fa-envelope-open text-primary me-2 fs-6"></i>
                                ) : (
                                  <i className="fa-regular fa-envelope me-2 fs-6"></i>
                                )}
                              </span>
                              <div className="media-body flex-grow-1">
                                <p className="noti-details">
                                  <span className="noti-title">
                                    {item.ScreenText}
                                  </span>
                                </p>
                                <p className="noti-time">
                                  <span className="notification-time">
                                    {timeAgo(item.CreatedOn)}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </Link>

                          {expandedIndex === index && (
                            <div className="accordion-body ms-3">
                              {item.EmailBody ? (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.EmailBody.replace(
                                      /\r?\n|\r/g,
                                      "<br />"
                                    ),
                                  }}
                                />
                              ) : (
                                <p>No Body available</p>
                              )}
                            </div>
                          )}
                        </li>
                      );
                    })}
                </ul>
              </div>

              <div className="topnav-dropdown-footer">
                <Link to="#">View all Notifications</Link>
              </div>
            </div>
          </li>
          {/* /Notifications */}

          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <img
                    src={UserIcon}
                    className="mt-1"
                    alt="usericon"
                    style={{ width: "1.4rem" }}
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">{userDataSession?.RoleName}</span>
                  <span className="user-role">
                    {userDataSession?.BusinessName}
                  </span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <img
                      src={UserIcon}
                      className="mt-1"
                      alt="usericon"
                      style={{ width: "1.4rem" }}
                    />
                    <span className="status online" />
                  </span>
                  <div
                    className={`profilesets ${
                      userDataSession.RoleId === 3 ||
                      userDataSession.RoleId === 5
                        ? "d-block"
                        : "d-none"
                    }`}
                  >
                    <h6>{userDataSession?.UserName}</h6>
                    <h5>{userDataSession?.StoreName}</h5>
                  </div>
                  <div
                    className={`profilesets ${
                      userDataSession.RoleId === 3 ||
                      userDataSession.RoleId === 5
                        ? "d-none"
                        : "d-block"
                    }`}
                  >
                    <h6>{userDataSession?.RoleName}</h6>
                    <h5>{userDataSession?.UserName}</h5>
                  </div>
                </div>
                <hr className="m-0" />
                <Link to="/expense-list" className="dropdown-item pb-0 text-info ms-1 d-none">
                Expenses
                </Link>
                <Link
                  className="dropdown-item pb-0 text-info ms-1"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightChPwd"
                  aria-controls="offcanvasRightChPwd"
                >
                  <i className="fa-solid fa-unlock-keyhole me-2 text-info"></i>
                  Change Password
                </Link>
                <Link
                  className="dropdown-item logout pb-0"
                  onClick={handleLogout}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </Link>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}

        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>

          <div className="dropdown-menu dropdown-menu-right">
            <div className="profilename">
              <div className="profileset">
                <span className="user-img">
                  <img
                    src={UserIcon}
                    className="mt-1"
                    alt="usericon"
                    style={{ width: "1.4rem" }}
                  />
                  {/* <span className="status online" /> */}
                </span>
                <div className="profilesets">
                  <h6>{userDataSession?.Name}</h6>
                  <h4 className="text-primary">{userDataSession?.username}</h4>
                </div>
              </div>
            </div>
            <hr className="m-0" />
            <Link to="#" className="dropdown-item pb-0 text-info ms-1">
            </Link>
            <Link
              className="dropdown-item pb-0 text-info ms-1"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightChPwd"
              aria-controls="offcanvasRightChPwd"
            >
              <i className="fa-solid fa-unlock-keyhole me-2 text-info"></i>
              Change Password
            </Link>
            <Link className="dropdown-item logout pb-0" to="/">
              <ImageWithBasePath
                src="assets/img/icons/log-out.svg"
                alt="img"
                className="me-2"
              />
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}

        {/* Change Passowrd */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightChPwd"
          aria-labelledby="offcanvasRightLabel"
          style={{ maxWidth: offcanvasWidth }}
        >
          <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">Change Password</h4>
            <div className="d-flex ms-auto align-items-center">
              <button
                type="button"
                className="btn-close text-reset ms-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleCancel}
              />
            </div>
          </div>
          <hr />
          <div className="offcanvas-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-2">
                  <label className="form-label">
                    User Name
                    <span className="fw-bold text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="username"
                    placeholder="Enter username"
                    value={formData.username}
                    onChange={handleChange}
                    autoComplete="new-username"
                    required
                  />
                </div>
                <div className="col-lg-12 col-md-12 mb-2">
                  <label className="form-label">
                    Old Password
                    <span className="fw-bold text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.oldPassword ? "text" : "password"}
                      className="form-control"
                      name="oldPassword"
                      placeholder="Enter your old password"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      autoComplete="new-password" // To avoid autofill
                      required
                    />
                    <button
                      type="button"
                      className="btn border"
                      onClick={() => togglePasswordVisibility("oldPassword")}
                    >
                      {showPassword.oldPassword ? (
                        <i className="fa-regular fa-eye-slash"></i>
                      ) : (
                        <i className="fa-regular fa-eye"></i>
                      )}
                    </button>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 mb-2">
                  <label className="form-label">
                    New Password
                    <span className="fw-bold text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.newPassword ? "text" : "password"}
                      className="form-control"
                      name="newPassword"
                      placeholder="Enter new password"
                      value={formData.newPassword}
                      onChange={handleChange}
                      autoComplete="new-password"
                      required
                    />
                    <button
                      type="button"
                      className="btn border"
                      onClick={() => togglePasswordVisibility("newPassword")}
                    >
                      {showPassword.newPassword ? (
                        <i className="fa-regular fa-eye-slash"></i>
                      ) : (
                        <i className="fa-regular fa-eye"></i>
                      )}
                    </button>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 mb-1">
                  <label className="form-label">
                    Confirm Password
                    <span className="fw-bold text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword.confirmPassword ? "text" : "password"}
                      className="form-control"
                      name="confirmPassword"
                      placeholder="Confirm password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      autoComplete="new-password"
                      required
                    />
                    <button
                      type="button"
                      className="btn border"
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                    >
                      {showPassword.confirmPassword ? (
                        <i className="fa-regular fa-eye-slash"></i>
                      ) : (
                        <i className="fa-regular fa-eye"></i>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="modal-footer-btn">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary me-2">
                  {pwdSubmitBtnLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* Change Passowrd */}
      </div>
    </>
  );
};

export default Header;
